import { render, staticRenderFns } from "./notifikasi.vue?vue&type=template&id=680594b1&scoped=true&"
import script from "./notifikasi.vue?vue&type=script&lang=js&"
export * from "./notifikasi.vue?vue&type=script&lang=js&"
import style0 from "./notifikasi.vue?vue&type=style&index=0&id=680594b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680594b1",
  null
  
)

export default component.exports